var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-4"},[_c('ClientNav'),_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12","lg":"3","xl":"2"}},[_c('ClientSide')],1),_c('v-col',{attrs:{"cols":"12","lg":"9","xl":"10"}},[_c('BMTable',{attrs:{"title":_vm.title}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }